// import logo from "./logo.svg";

import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
import moment from "moment";
import {useEffect, useState} from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import IconCircle from "../components/svgAssets/IconCircle";
import {getUserBookings} from "../redux/action/bookings.action";
import ArrowForward from "@mui/icons-material/ArrowForward";
import {IconButton} from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";


function Bookings(props) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [bookings, setBookings] = useState([]);
  const [meta, setMeta] = useState({ totalPages: 1, itemsPerPage: 5 });

  const [type, setType] = useState("upcoming");
  useEffect(() => {
    dispatch(getUserBookings({ page, limit: meta.itemsPerPage, type }))
        .then(({ data, meta }) => {
          setBookings(data);
          setMeta(meta);
        })
        .catch(console.error);
  }, [page, type]);

  const handleNext = () => {
    if (page < meta.totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };


console.log(bookings);
  return (
    <div className={classes.root}>
      <Helmet>
        <title>Studio DMI | Profile</title>
        <meta charset="UTF-8" />
        <meta name="description" content="" />
        <meta name="referrer" content="origin" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <Container maxWidth="md">
        <br />
        <Box >
            <Box display="flex" flexDirection="column" textAlign="center">
              <Typography variant="h4" color="initial">
                My bookings
              </Typography>
            </Box>

              <Box mt={2} mb={2}>
                <Tabs
                    value={type}
                    onChange={(e, newValue) => {
                      setPage(1);
                      setType(newValue);
                    }}
                    centered
                >
                  <Tab label="Upcoming" value="upcoming" />
                  <Tab label="Past" value="past" />
                </Tabs>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                width="100%"
              >

                {bookings.map((item, index) => (
                    <Box key={item._id}>
                      <Grid
                          container
                          alignItems="center"
                          justifyContent="space-around"
                          pt={0}
                      >
                        <Grid item md={9} xs={12}>
                          <Box display="flex" alignItems="center">

                            <Box display="flex" position="relative">
                              <IconCircle
                                  style={{
                                    color: "rgba(0,0,0,0.001)",
                                    width: 39,
                                    height: 39,
                                  }}
                              />
                              <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  position="absolute"
                                  width="100%"
                                  height="100%"
                              >
                                <Typography variant="body1" color="secondary">
                                  {index + 1 + (meta.currentPage - 1) * meta.itemsPerPage}
                                </Typography>
                              </Box>
                            </Box>
                            <Box ml={3}>
                              <Typography variant="body1" color="initial">
                                {item.name}
                              </Typography>
                              <Typography variant="body2" color="initial">
                                {item.email}
                              </Typography>
                              <Typography variant="body2" color="initial">
                                {item.phone}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item md={3} xs={12} sx={{
                          mt: { xs: 2, md: 0 }
                        }}>
                          <Typography
                              align="center"
                              variant="body1"
                              color="initial"
                              className={classes.dateBox}
                          >
                            {moment(item.startTime).format("lll")}
                          </Typography>
                          <Typography mt={1} variant="body2" color="initial">
                            Booked at: {moment(item.createdAt).format("lll")}
                          </Typography>
                          <Typography variant="h6" color="primary">
                            {item.status}
                          </Typography>
                        </Grid>

                      </Grid>

                      <Box mt={1}>
                        <Typography variant="body2" color="initial">
                          Agreement:{" "}
                          <a href={item.agreementUrl} target="_blank" rel="noreferrer">
                            Open PDF
                          </a>
                        </Typography>
                      </Box>

                      <br />
                      <Divider className={classes.greyDivider} />
                      <br />
                    </Box>
                ))}

                <Box display="flex" justifyContent="center" alignItems="center" mt={3}>
                  <IconButton disabled={page === 1} onClick={handlePrev}>
                    <ArrowBack />
                  </IconButton>

                  <Typography variant="body1" mx={2}>
                    Page {page} of {meta.totalPages}
                  </Typography>

                  <IconButton disabled={page === meta.totalPages} onClick={handleNext}>
                    <ArrowForward />
                  </IconButton>
                </Box>
              </Box>
          </Box>
      </Container>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    marginTop: 100,
  },
  payPalSelect: {
    width: "100%",
    border: "1px solid #A5B0BE",
    borderRadius: "4px",
    boxSizing: "border-box",
  },
  menuBtn: {
    cursor: "pointer",
  },
  verticalDivider: {
    height: "auto",
    width: "2px",
    color: "#dbdbdb",
  },
  greyDivider: {
    color: "#dbdbdb",
  },
  textBtn: {
    color: theme.palette.secondary.main,
  },

  dateBox: {
    backgroundColor: "#AAC9DD",
    borderRadius: "44px",
    padding: "5px 0",
  },
}));

export default Bookings;
